export const cardVariants = {
    initial: (first: boolean) => {
        return {
            opacity: 0,
            translateX: first ? "100%" : "-100%",
        };
    },
    animate: {
        opacity: 1,
        translateX: 0,
    },
    exit: (first: boolean) => {
        return {
            opacity: 0,
            translateX: first ? "100%" : "-100%",
        };
    },
};
